import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { HEADER_VARIABLES } from './Header';

import { filterProps } from 'utils/helpers';

interface IMenuButton {
  open: boolean;
  onToggle: JSX.IntrinsicElements['button']['onClick'];
}

export enum MENU_BUTTON_VARIABLES {
  baseUnit = '--base-unit',
}

const StyledMenuButton = styled('button', filterProps('open'))<Pick<IMenuButton, 'open'>>`
  ${({ theme: { durations, mq }, open }) => css`
    ${MENU_BUTTON_VARIABLES.baseUnit}: 0.375rem;

    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: calc(var(${MENU_BUTTON_VARIABLES.baseUnit}) * -1);
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
    padding: calc(var(${MENU_BUTTON_VARIABLES.baseUnit}) * 2) var(${MENU_BUTTON_VARIABLES.baseUnit});
    width: calc((var(${MENU_BUTTON_VARIABLES.baseUnit}) * 2) + 2.25rem);
    height: calc((var(${MENU_BUTTON_VARIABLES.baseUnit}) * 2) + 2.125rem);

    &::before,
    &::after {
      transform-origin: 2.125rem;
      transition: all ${durations.long};
      border-radius: var(--base-unit);
      background-color: var(${HEADER_VARIABLES.accentColor});
      width: 100%;
      height: var(${MENU_BUTTON_VARIABLES.baseUnit});
      content: '';
    }

    &::before {
      top: 0;
    }

    &::after {
      bottom: 0;
    }

    ${open &&
    css`
      &::before,
      &::after {
        width: 2.125rem;
      }

      &::before {
        transform: rotate(-45deg) translateY(calc(var(${MENU_BUTTON_VARIABLES.baseUnit}) * -1));
      }

      &::after {
        transform: rotate(45deg) translateY(var(${MENU_BUTTON_VARIABLES.baseUnit}));
      }
    `}

    ${mq.md} {
      display: flex;
    }
  `}
`;

const MenuButton: React.FC<IMenuButton> = ({ open, onToggle }) => (
  <StyledMenuButton open={open} onClick={onToggle} />
);

export default MenuButton;
